const reactQueryBuilder = require('react-querybuilder');

function isQueryEmpty(query) {
  return !query?.rules?.length;
}

function combineQueries(...queries) {
  const query = queries.filter(q => !isQueryEmpty(q)).reduce((acc, q) => ({
    ...acc,
    rules: [...acc.rules, ...(q.combinator === 'and' ? q.rules : [q])],
  }), { combinator: 'and', rules: [] });
  return query;
}

function stripDateRules(query) {
  if (!query?.rules?.length) {
    return query;
  }

  const rules = query.rules.flatMap((rule) => {
    if (rule.rules) {
      const nested = stripDateRules(rule);
      return nested.rules?.length ? [nested] : [];
    }
    return rule.field === 'date' ? [] : [rule];
  });

  return { ...query, rules };
}

function getDateQuery({ dateRange }) {
  if (!dateRange) {
    return null;
  }

  return {
    combinator: 'and',
    rules: [{
      field: 'date',
      value: [dateRange.startDate, dateRange.endDate],
      operator: 'between',
    }],
  };
}

function getBaseQuery({ customerId, dataSourceIds, websiteBaseUrls }) {
  const baseQuery = {
    combinator: 'and',
    rules: [],
  };

  if (dataSourceIds?.length > 0) {
    baseQuery.rules.push({
      field: 'dataSourceId',
      value: dataSourceIds,
      operator: 'in',
    });
  } else if (customerId) {
    baseQuery.rules.push({
      field: 'customerId',
      value: customerId,
      operator: '=',
    });
  }

  if (websiteBaseUrls?.length > 0) {
    baseQuery.rules.push({
      combinator: 'or',
      rules: websiteBaseUrls.map(url => ({
        field: 'websiteBaseUrl',
        operator: 'beginsWith',
        value: url,
      })),
    });
  }

  return baseQuery;
}

function getQuery({ field, value, operator }) {
  return {
    combinator: 'and',
    rules: [{
      field,
      value,
      operator,
    }],
  };
}

function isSameQuery(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  return reactQueryBuilder.formatQuery(a, 'json_without_ids') === reactQueryBuilder.formatQuery(b, 'json_without_ids');
}

module.exports = {
  reactQueryBuilder,
  isQueryEmpty,
  isSameQuery,
  combineQueries,
  stripDateRules,
  getDateQuery,
  getBaseQuery,
  getQuery,
};
